<template>
  <div class="location-create-section">
    <b-card>
      <div v-if="mode === 'create'">
        <h2 class="m__b--25">
          Create Package
        </h2>
      </div>

      <b-form>
        <b-form-group label="Name">
          <b-form-input v-model="itemData.name" placeholder="Name" />
        </b-form-group>

        <b-form-group label="Description">
          <b-textarea
            v-model="itemData.description"
            placeholder="Description"
          />
        </b-form-group>

        <b-form-group label="Category">
          <b-form-input v-model="itemData.category" placeholder="Category" />
        </b-form-group>

        <b-form-group label="Minimal Package">
          <b-form-input
            v-model="itemData.min_package"
            type="number"
            placeholder="Minimal Package"
          />
        </b-form-group>

        <b-form-group label="Departure Location">
          <b-form-input
            v-model="itemData.departure_location"
            placeholder="Departure Location"
          />
        </b-form-group>

        <b-form-group label="Location">
          <vue-treeselect
            valueFormat="object"
            :options="locationState.list"
            v-model="itemData.location_id"
            placeholder="Location"
          >
            <div slot="value-label" slot-scope="{ node }">
              {{ node.raw.name }}
            </div>
            <label slot="option-label" slot-scope="{ node }">
              {{ node.raw.name }}
            </label>
          </vue-treeselect>
        </b-form-group>

        <b-form-group label="Price">
          <vue-autonumeric
            class="autonumeric-field"
            v-model="itemData.price"
            :options="{
              digitGroupSeparator: '.',
              decimalCharacter: ',',
              decimalCharacterAlternative: '.',
              currencySymbol: 'Rp\u00a0',
              currencySymbolPlacement: 'p',
              roundingMethod: 'U',
              minimumValue: '0'
            }"
            placeholder="Enter Price"
          />
        </b-form-group>

        <b-form-group label="Kid Price">
          <vue-autonumeric
            class="autonumeric-field"
            v-model="itemData.kid_price"
            :options="{
              digitGroupSeparator: '.',
              decimalCharacter: ',',
              decimalCharacterAlternative: '.',
              currencySymbol: 'Rp\u00a0',
              currencySymbolPlacement: 'p',
              roundingMethod: 'U',
              minimumValue: '0'
            }"
            placeholder="Enter Kid Price"
          />
        </b-form-group>

        <b-form-group label="Attraction">
          <vue-treeselect
            valueFormat="object"
            :multiple="true"
            :options="attractionState.list"
            v-model="itemData.attractions"
            placeholder="Attraction"
          >
            <div slot="value-label" slot-scope="{ node }">
              {{ node.raw.name }}
            </div>
            <label slot="option-label" slot-scope="{ node }">
              {{ node.raw.name }}
            </label>
          </vue-treeselect>
        </b-form-group>
      </b-form>
    </b-card>

    <div class="float-to-right m__t--55 m__b--60">
      <b-button
        class="m__r--10 cancel action-push"
        @click="$router.replace('/home/package')"
        >Cancel</b-button
      >
      <b-button class="save action-push" @click="save">Save</b-button>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
// import VueAutonumeric from 'vue-autonumeric/src/components/VueAutonumeric';

export default {
  name: 'createPackage',
  // components: {
  //   VueAutonumeric
  // },
  data() {
    return {
      mode: 'create',
      itemData: {
        id: 0,
        location_id: null,
        name: null,
        description: '',
        category: null,
        min_package: null,
        departure_location: null,
        departure_time: new Date(),
        price: null,
        kid_price: null,
        attractions: []
      }
    };
  },
  watch: {
    'packageState.detail': function(newVal) {
      this.itemData = {
        id: newVal.id,
        name: newVal.name,
        description: newVal.description,
        location_id: newVal.location_id
          ? { id: newVal.location_id.id }
          : { id: 0 },
        category: newVal.category,
        min_package: newVal.min_package,
        departure_location: newVal.departure_location,
        departure_time: newVal.departure_time,
        price: newVal.price,
        kid_price: newVal.kid_price,
        attractions: [...newVal.attractions]
      };
    }
  },
  computed: {
    ...mapState('StorePackage', ['packageState']),
    ...mapState('StoreAttraction', ['attractionState']),
    ...mapState('StoreLocation', ['locationState']),
    ...mapGetters('StoreLocation', ['optionsLocation'])
  },
  created() {
    const req = {
      sort: '',
      per_page: 0,
      page: 0,
      search: ''
    };
    this.$store.dispatch('StoreLocation/listLocation', req);
    this.$store.dispatch('StoreAttraction/listAttraction', req);

    if (this.$route.path.includes('create')) {
      this.mode = 'create';
    } else {
      this.mode = 'edit';
      this.$store.dispatch('StorePackage/detailPackage', {
        id: this.$route.params.id
      });
    }
  },
  methods: {
    save() {
      const req = {
        id: this.$route.params.id ? this.$route.params.id : 0,
        name: this.itemData.name,
        description: this.itemData.description,
        location_id: this.itemData.location_id
          ? this.itemData.location_id.id
          : 0,
        category: this.itemData.category,
        min_package: this.itemData.min_package,
        departure_location: this.itemData.departure_location,
        departure_time: new Date(),
        price: this.itemData.price,
        kid_price: this.itemData.kid_price,
        attractions: [...this.itemData.attractions.map(data => data.id)]
      };
      if (this.mode === 'create') {
        this.$store.dispatch('StorePackage/createPackage', req);
      } else {
        this.$store.dispatch('StorePackage/editPackage', req);
      }
    }
  }
};
</script>

<style lang="scss">
.Attarction-create-section {
  h2 {
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 37px;
    color: #1d2d4e;
  }
  legend {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 37px;
    color: #1d2d4e;
  }
  .form-control::placeholder {
    color: #bdbdbd;
  }
  button.action-push {
    width: 147px;
    height: 45px;
    border-radius: 3px;
    border: unset;
    &.cancel {
      background: #ffffff;
      box-shadow: 0px 4px 20px #f0efec;
      color: #ababab;
    }
    &.save {
      background: #fb9c0a;
      box-shadow: 0px 4px 20px rgba(251, 156, 10, 0.3);
    }
  }
}
</style>
